export default __webpack_public_path__ + "static/media/Level15.a8df3c7c.svg";